import React from "react";
import { SignatureCompletionData } from "../../../hooks";
import { omniAuthService } from "../../../services";
import { MyDataAgreementPage } from "../../common";

const MyDataRequestAgreementScreen: React.FC = () => {
  // 전자서명 완료 시 여러 기관 생성 API 호출
  const handleSignatureComplete = async (data: SignatureCompletionData) => {
    await omniAuthService.submitTransmission({
      provideInstitutionTransmissionList:
        data.provideInstitutionTransmissionList,
    });
  };

  return (
    <MyDataAgreementPage
      title="마이데이터 전송요구서"
      successMessage="회원가입이 완료되었습니다!"
      buttonText="완료하기"
      autoAgreeButtonText="모두 동의하고 완료하기"
      onSignatureComplete={handleSignatureComplete}
    />
  );
};

export default MyDataRequestAgreementScreen;
